import storeKeys from "../data/storeKeys";

export function createSessionCookie(session) {
    window.localStorage.setItem(storeKeys.SessionObj, objectToSessionString(session));
}


export function initialiseSurvey(callBack) {
    const queryParams = new URLSearchParams(window.location.search);
    let qs = queryParams.get('s');
    if (qs === null || qs === undefined || qs === "") {
        return formatSessionObjError("No survey id in Url");
    }

    createSession(qs, callBack);
}

export async function createSession(surveyId, callBack) {
    try {
        await fetch( process.env.REACT_APP_API_URL + 'session/create',{
            method: 'POST',
            headers: {
               'Accept' : 'application/json',
               'Content-Type' : 'application/json' 
           },
   
           body : JSON.stringify({survey: surveyId})            
        })
        .then(res => res.json())
        .then(data => {
            callBack(formatSessionObj(
                data.sessionId,
                data.surveyId,
                data.sessionStart
            ));
        })
    }catch(error){
        return formatSessionObjError("Failed to get session from API");
    }

    return true;  
}

export function saveResults(data) {
    try {
          fetch( process.env.REACT_APP_API_URL + 'session/result',{
              method: 'POST',
              headers: {
                'Accept' : 'application/json',
                'Content-Type' : 'application/json' 
            },
    
            body : JSON.stringify(data)            
          })
          .then(res => res.json())
          .then(data => {console.log(data)}
          )
      }catch(error){
        console.log("Failed to save results", data)
      }
      return true;  
}

export function formatSessionObjError(error) {
    return {
        success  : false,
        'error'  : error
    }
}

export function formatSessionObj(sessionId, surveyId, sessionStart) {
    return {
        success      : true,
        sessionId    : sessionId,
        surveyId     : surveyId,
        sessionStart : sessionStart
    }
}

export function sessionStringToObject(sessionStr) {
    let sessionArr = sessionStr.split("|");
    if (sessionArr.length !== 3 ) { 
        return {success: false, 'error': 'Not a valid session string'}
    }

    return formatSessionObj(sessionArr[0], sessionArr[1], sessionArr[2]);
}

export function objectToSessionString(sessionJson){
    return sessionJson.sessionId + "|" + sessionJson.surveyId + "|" + sessionJson.sessionStart;
}

export function sessionCookieExists() {
    return (window.localStorage.getItem(storeKeys.SessionObj) !== null);
}

export function getSessionObj() {
    if (!sessionCookieExists()) return {sucess:false, error: 'no session cookie'};
    return sessionStringToObject(window.localStorage.getItem(storeKeys.SessionObj));
}